import { Dollar } from "flowbite-react-icons/outline";
import { useCallback, useMemo, useState } from "preact/hooks";
import PropTypes from "prop-types";

export default function NumberInput({
  maxLength = 7,
  onChange,
  placeholder = "5.00",
  name,
  value,
  labelText,
  isCurrency = true,
  minValue,
  maxValue,
  disabled,
  className = "mb-1",
  inputClassName,
  description,
  suffix,
  testID,
}) {
  const prefix = useMemo(() => {
    if (isCurrency) {
      return <Dollar className="h-[1em] opacity-50" />;
    }
    return undefined;
  }, [isCurrency]);

  const [valid, setValid] = useState(true);

  const handleChange = useCallback(
    (event) => {
      event.target.value = Math.abs(event.target.value);
      event.target.valueAsNumber = Math.abs(event.target.valueAsNumber);
      setValid(event.target.validity.valid);
      onChange?.(event);
    },
    [onChange],
  );

  const handleBlur = useCallback(() => {
    if (value < minValue) {
      onChange({ target: { value: minValue, valueAsNumber: minValue, name } });
    } else if (value > maxValue) {
      onChange({ target: { value: maxValue, valueAsNumber: maxValue, name } });
    }
  }, [value, minValue, name, onChange, maxValue]);

  return (
    <fieldset className={`fieldset ${className} px-1`}>
      <legend className="fieldset-legend select-none -mb-0.5 pb-0">{labelText}</legend>
      <label className={`input w-full ${inputClassName}`}>
        {prefix && <span className="label">{prefix}</span>}
        <input
          data-testid={testID}
          disabled={disabled}
          min={minValue}
          max={maxValue}
          type="number"
          name={name}
          maxLength={maxLength}
          value={value}
          onChange={handleChange}
          placeholder={placeholder}
          onBlur={handleBlur}
          className="grow"
        />
        {suffix && <span className="label">{suffix}</span>}
      </label>
      {description && valid && <p className="fieldset-label">{description}</p>}
    </fieldset>
  );
}

NumberInput.propTypes = {
  maxLength: PropTypes.number,
  onChange: PropTypes.func.isRequired,
  placeholder: PropTypes.string,
  testID: PropTypes.string,
  description: PropTypes.oneOfType([PropTypes.string, PropTypes.element]),
  suffix: PropTypes.oneOfType([PropTypes.string, PropTypes.element]),
  name: PropTypes.string,
  value: PropTypes.number,
  labelText: PropTypes.string,
  isCurrency: PropTypes.bool,
  minValue: PropTypes.any,
  maxValue: PropTypes.any,
  disabled: PropTypes.bool,
  className: PropTypes.string,
};
